import { useParams } from '../../contexts/RouterContext';

/**
 * Hook to get the slug from the URL
 */
const useSlug = () => {
  const { slug } = useParams<{ slug: string }>();

  return slug;
};

export default useSlug;
